export enum GlobalFunctionsEnum {
  GLOBAL_ACCESS = 'GLOBAL_ACCESS'
}
